module.exports = __webpack_public_path__ + "images/offer_logos.png";